import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, styled as muiStyled } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Image from "next/image";
import { getSignUpBenefit } from "src/api/member";
const SignUpBenefit = ()=>{
    var _signUpBenefit_title1, _signUpBenefit_title11, _signUpBenefit_title2, _signUpBenefit_title21;
    const { data: signUpBenefit  } = useQuery([
        "signUpBenefit"
    ], ()=>getSignUpBenefit(), {
        staleTime: Infinity
    });
    return /*#__PURE__*/ _jsxs(InfoBox, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bold28",
                sx: {
                    textAlign: "center",
                    color: signUpBenefit === null || signUpBenefit === void 0 ? void 0 : (_signUpBenefit_title1 = signUpBenefit.title1) === null || _signUpBenefit_title1 === void 0 ? void 0 : _signUpBenefit_title1.color
                },
                children: (signUpBenefit === null || signUpBenefit === void 0 ? void 0 : (_signUpBenefit_title11 = signUpBenefit.title1) === null || _signUpBenefit_title11 === void 0 ? void 0 : _signUpBenefit_title11.text) || "지금 가입하면"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bold28",
                sx: {
                    textAlign: "center",
                    color: signUpBenefit === null || signUpBenefit === void 0 ? void 0 : (_signUpBenefit_title2 = signUpBenefit.title2) === null || _signUpBenefit_title2 === void 0 ? void 0 : _signUpBenefit_title2.color
                },
                children: (signUpBenefit === null || signUpBenefit === void 0 ? void 0 : (_signUpBenefit_title21 = signUpBenefit.title2) === null || _signUpBenefit_title21 === void 0 ? void 0 : _signUpBenefit_title21.text) || "아주 좋아요!"
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Image, {
                    src: signUpBenefit === null || signUpBenefit === void 0 ? void 0 : signUpBenefit.imageUrl,
                    fill: true,
                    alt: "sign up benefit image"
                })
            })
        ]
    });
};
const InfoBox = muiStyled("section")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        maxWidth: "440px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "60px 0",
        margin: "40px 0",
        div: {
            position: "relative",
            width: "312px",
            height: "312px",
            textAlign: "center",
            margin: "32px 0",
            img: {
                objectFit: "contain"
            }
        },
        "@media (max-width: 1200px)": {
            padding: "0",
            margin: "0",
            div: {
                margin: "32px 0 0 0"
            }
        },
        "@media (max-width: 768px)": {
            div: {
                width: "240px",
                height: "240px"
            }
        }
    };
});
export default SignUpBenefit;
